// extracted by mini-css-extract-plugin
export default {"secondaryBlueButton":"lb8Xvb1uNCr-eZDyD6weP","secondaryBlueButtonstyled":"_1iiCQ0Q3FORCHSeP15SUC8"};